<template>
  <div>
    <div>
      <div>
        <b-modal
          hide-footer
          v-model="show"
          id="modal-1"
          centered
          title="Görüntü Kırpma"
          size="lg"
        >
          <b-card-text>
            <h5>
              Görüntüyü istenilen şekilde kırpıp kaydedin. Fare tekerleği ile
              yakınlaştırıp uzaklaştırabilirsiniz.
            </h5>
            <!-- <cropper
              ref="cropper"
              image-restriction="stencil"
              :default-size="{ width: width, height: height }"
              :resizeImage="{ wheel: wheel }"
              :stencil-props="{
                handlers: {},
                movable: movable,
              }"
              :src="cropImage.src"
              @change="onChange"
            /> -->
            <cropper
              ref="cropper"
              image-restriction="stencil"
              :default-size="{ width: width, height: height }"
              :resizeImage="{ wheel: wheel }"
              :stencil-props="{
                handlers: {},
                movable: movable,
              }"
              :src="cropImage.src"
              @change="onChange"
            />
            <div class="d-flex align-items-center justify-content-between mt-2">
              <p><b>Genişlik:</b> {{ coordinates.width }}px</p>
              <p><b>Yükseklik:</b> {{ coordinates.height }}px</p>
            </div>
            <div class="d-flex align-items-center justify-content-between mt-2">
              <div>
                <b-form-group label="Genişlik" label-for="width" class="mb-2">
                  <b-form-input
                    id="width"
                    v-model="resized.width"
                    :disabled="!resizable"
                  />
                </b-form-group>
              </div>
              <div>
                <b-form-group label="Yükseklik" label-for="height" class="mb-2">
                  <b-form-input
                    id="height"
                    v-model="resized.height"
                    :disabled="!resizable"
                  />
                </b-form-group>
              </div>
            </div>
            <div>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-2 mb-2 float-left mr-2"
                v-on:click="crop"
              >
                {{ cropMessage ? "Kırpılıyor" : "Kırp" }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-2 mb-2 float-left mr-2"
                v-on:click="resize()"
                >Yeniden Boyutlandır</b-button
              >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-2 mb-2 float-right"
                v-on:click="closeCropModal"
              >
                Kapat
              </b-button>
            </div>
          </b-card-text>
        </b-modal>
      </div>
      <b-form-group :label="title" label-for="image">
        <validation-provider
          #default="{ errors }"
          :rules="{ required: required }"
          :name="title"
        >
          <b-media
            no-body
            vertical-align="center"
            class="flex-column flex-md-row"
            @drop.prevent="dropImageUpload($event), loadImage($event, 'drop')"
            @dragover.prevent
          >
            <b-media-aside>
              <b-img
                :src="featuredImage"
                width="300"
                height="200"
                style="object-fit: contain"
                class="rounded o mr-2 mb-1 mb-md-0"
              />
            </b-media-aside>

            <b-media-aside v-if="base64Image != null">
              <b-img
                :src="base64Image"
                width="300"
                height="200"
                style="object-fit: cover"
                class="rounded object-cover mr-2 mb-1 mb-md-0"
              />
            </b-media-aside>
            <b-media-body>
              <small class="text-muted"
                >Gerekli görüntü çözünürlüğü {{ width }}x{{ height }}, görüntü boyutu
                10mb.</small
              >
              <b-card-text class="my-50">
                <b-link id="blog-image-text">
                  C:\{{ loadedImage ? loadedImage.name : "banner.jpg" }}
                </b-link>
              </b-card-text>
              <div class="d-inline-block">
                <b-form-file
                  v-model="loadedImage"
                  placeholder="Lütfen bir görsel seçiniz"
                  @change="handleImageUpload($event), loadImage($event, 'input')"
                  accept="image/*"
                />
              </div>
            </b-media-body>
          </b-media>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="mt-2 mb-2"
        v-on:click="openCropModal"
        :disabled="loadedImage == null"
      >
        Görüntüle
      </b-button>
    </div>
  </div>
</template>
<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import "vue-advanced-cropper/dist/theme.compact.css";

import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BCol,
  BImg,
  BRow,
  BLink,
  BCard,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormFile,
  BCardText,
  BMediaBody,
  BFormInput,
  BFormGroup,
  BMediaAside,
  BInputGroup,
  BFormTextarea,
  BButtonToolbar,
} from "bootstrap-vue";

import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

export default {
  components: {
    BCol,
    BImg,
    BRow,
    BLink,
    BCard,
    BButton,
    BForm,
    BMedia,
    BAlert,
    BSpinner,
    BFormFile,
    BCardText,
    BMediaBody,
    BFormInput,
    BFormGroup,
    BMediaAside,
    BInputGroup,
    BFormTextarea,
    BButtonToolbar,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
    Cropper,
  },
  directives: {
    Ripple,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    width: 0,
    height: 0,
    wheel: Boolean,
    movable: Boolean,
    resizable: Boolean,
    imageUrl: {},
    loadedImage: null,
    required: Boolean,
    featuredImageSize: String,
    featuredImageFromApi: String,
  },
  data() {
    return {
      show: false,
      image: null,
      base64Image: null,
      resized: {
        width: 0,
        height: 0,
      },
      coordinates: {
        top: 0,
        left: 0,
        width: 0,
        height: 0,
      },
      cropImage: {
        src: null,
        type: null,
      },
      cropedImage: null,
      cropMessage: false,
      featuredImage:
        this.featuredImageFromApi != null
          ? this.featuredImageFromApi
          : require("@/assets/images/placeholder/1920x1080.png"),
    };
  },
  watch: {},
  methods: {
    crop() {
      const { coordinates, canvas } = this.$refs.cropper.getResult();
      this.coordinates = coordinates;
      this.base64Image = canvas.toDataURL();
      this.cropedImage = this.base64ToBlob(this.base64Image);
      this.image = this.cropedImage;

      console.log(this.cropedImage);
      console.log(this.image);

      this.cropMessage = true;
      setTimeout(() => {
        this.cropMessage = false;
      }, 1000);
    },
    reset() {
      this.cropImage = {
        src: null,
        type: null,
      };
    },
    resize2() {
      this.resized.width = this.width;
      this.resized.height = this.height;
      this.$refs.cropper.setCoordinates({
        width: this.resized.width,
        height: this.resized.height,
        left: this.coordinates.left,
        top: this.coordinates.top,
      });
    },
    resize() {
      this.$refs.cropper.setCoordinates({
        width: this.resized.width,
        height: this.resized.height,
        left: this.coordinates.left,
        top: this.coordinates.top,
      });
    },
    openCropModal() {
      this.show = true;
    },
    closeCropModal() {
      this.show = false;
    },
    onChange({ coordinates, canvas }) {
      this.coordinates = coordinates;

      this.resized.width = this.coordinates.width;
      this.resized.height = this.coordinates.height;
    },
    getMimeType(file, fallback = null) {
      const byteArray = new Uint8Array(file).subarray(0, 4);
      let header = "";
      for (let i = 0; i < byteArray.length; i++) {
        header += byteArray[i].toString(16);
      }
      switch (header) {
        case "89504e47":
          return "image/png";
        case "47494638":
          return "image/gif";
        case "ffd8ffe0":
        case "ffd8ffe1":
        case "ffd8ffe2":
        case "ffd8ffe3":
        case "ffd8ffe8":
          return "image/jpeg";
        default:
          return fallback;
      }
    },
    loadImage(event, type) {
      // Reference to the DOM input element
      const { files } = type == "drop" ? event.dataTransfer : event.target;
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.cropImage.src) {
          URL.revokeObjectURL(this.cropImage.src);
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0]);

        // 3. The steps below are designated to determine a file mime type to use it during the
        // getting of a cropped image from the canvas. You can replace it them by the following string,
        // but the type will be derived from the extension and it can lead to an incorrect result:
        //
        this.cropImage = {
          src: blob,
          type: files[0].type,
        };

        // Create a new FileReader to read this image binary data
        const reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.cropImage" refers to the image of Vue component
          this.cropImage = {
            // Set the image source (it will look like blob:http://example.com/2c5270a5-18b5-406e-a4fb-07427f5e7b94)
            src: blob,
            // Determine the image type to preserve it during the extracting the image from canvas:
            type: this.getMimeType(type == e.target.result, files[0].type),
          };
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsArrayBuffer(files[0]);
      }
    },

    base64ToBlob(base64Image) {
      // Split into two parts
      const parts = base64Image.split(";base64,");

      // Hold the content type
      const imageType = parts[0].split(":")[1];

      // Decode Base64 string
      const decodedData = window.atob(parts[1]);

      // Create UNIT8ARRAY of size same as row data length
      const uInt8Array = new Uint8Array(decodedData.length);

      // Insert all character code into uInt8Array
      for (let i = 0; i < decodedData.length; ++i) {
        uInt8Array[i] = decodedData.charCodeAt(i);
      }

      // Return BLOB image after conversion
      return new Blob([uInt8Array], { type: imageType });
    },
    fileSizeControl(img) {
      if (img.size > 10000000) {
        this.$swal({
          title: "Hata!",
          text:
            "10 MB'dan büyük görsel yükleyemezsiniz! Yüklenecek görselin 10 MB'dan küçük olduğuna emin olun",
          icon: "error",
          confirmButtonText: "Tamam",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        }).then((result) => {
          if (result.value) {
          }
        });
        return;
      }
    },

    dropImageUpload(event) {
      this.loadedImage = event.dataTransfer.files[0];
      this.featuredImage = URL.createObjectURL(this.loadedImage);
      this.fileSizeControl(this.loadedImage);
      this.show = true;
    },
    handleImageUpload(event) {
      console.log(event);
      this.loadedImage = event.target.files[0];
      this.featuredImage = URL.createObjectURL(this.loadedImage);
      this.fileSizeControl(this.loadedImage);
      this.show = true;
    },
  },
  mounted() {
    if (this.imageUrl != null) {
      this.featuredImage = this.imageUrl;
    }
  },
  setup() {},
};
</script>
